import { render, staticRenderFns } from "./DecisionData.vue?vue&type=template&id=3c305add&"
import script from "./DecisionData.vue?vue&type=script&lang=js&"
export * from "./DecisionData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports